"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _router = require("@reach/router");

var _immer = _interopRequireDefault(require("immer"));

var _antd = require("antd");

var _lodash = require("lodash");

var _icons = require("@ant-design/icons");

var _EditorFields = _interopRequireDefault(require("./EditorFields"));

var _Input = _interopRequireDefault(require("./Input"));

var _Select = _interopRequireDefault(require("./Select"));

var _Caption = _interopRequireDefault(require("./Caption"));

var _PostTreeSelect = _interopRequireDefault(require("./PostTreeSelect"));

var _MediaLibrary = _interopRequireDefault(require("./MediaLibrary"));

var _FilePicker = _interopRequireDefault(require("./editorFields/FilePicker"));

var _actions = require("../actions");

var _store = require("../store");

var _theme = require("../theme");

var _utils = require("../utils");

var _routes = _interopRequireDefault(require("../routes"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var EditorSidebar = function EditorSidebar(props) {
  var _sites$siteID2, _sites$siteID2$editor, _authUser$capabilitie, _fields$themeOptions, _fields$themeOptions$;

  var editable = props.editable,
      onToggleSidebar = props.onToggleSidebar,
      onUndoChanges = props.onUndoChanges,
      rest = (0, _objectWithoutProperties2.default)(props, ["editable", "onToggleSidebar", "onUndoChanges"]);

  var _ref4 = (0, _store.useStore)(),
      _ref5 = _slicedToArray(_ref4, 2),
      _ref5$ = _ref5[0],
      config = _ref5$.config,
      authUser = _ref5$.authState.authUser,
      _ref5$$cmsState = _ref5$.cmsState,
      sites = _ref5$$cmsState.sites,
      siteID = _ref5$$cmsState.siteID,
      _ref5$$editorState = _ref5$.editorState,
      site = _ref5$$editorState.site,
      post = _ref5$$editorState.post,
      siteHasChanged = _ref5$$editorState.siteHasChanged,
      postHasChanged = _ref5$$editorState.postHasChanged,
      dispatch = _ref5[1];

  var fields = config.fields;

  var _ref6 = (0, _react.useState)(null),
      _ref7 = _slicedToArray(_ref6, 2),
      loading = _ref7[0],
      setLoading = _ref7[1];

  var _ref8 = (0, _react.useState)('content'),
      _ref9 = _slicedToArray(_ref8, 2),
      sidebar = _ref9[0],
      setSidebar = _ref9[1];

  var _ref10 = (0, _react.useState)(48),
      _ref11 = _slicedToArray(_ref10, 2),
      expiryDate = _ref11[0],
      setExpiryDate = _ref11[1];

  var _ref12 = (0, _react.useState)(null),
      _ref13 = _slicedToArray(_ref12, 2),
      previewLink = _ref13[0],
      setPreviewLink = _ref13[1];

  var handleChangePost = function handleChangePost(name, value) {
    var nextPost = (0, _immer.default)(post, function (draft) {
      return (0, _lodash.set)(draft, "".concat(name), value);
    });
    dispatch({
      type: 'UPDATE_EDITOR_POST',
      payload: nextPost
    });
  };

  var handleSelectRevision = /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(postID) {
      var result, content, title, revisionID;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(postID);
              _context.next = 3;
              return _actions.postActions.getPost({
                siteID: siteID,
                postID: postID
              }, dispatch, config);

            case 3:
              result = _context.sent;

              if (result) {
                // Update existing post with title, content, post date and revisionID.
                content = result.content, title = result.title, revisionID = result.revisionID;
                dispatch({
                  type: 'UPDATE_EDITOR_POST',
                  payload: _objectSpread(_objectSpread({}, post), {}, {
                    content: content,
                    title: title,
                    revisionID: revisionID,
                    siteID: siteID
                  })
                });
              }

              setLoading(null);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSelectRevision(_x) {
      return _ref14.apply(this, arguments);
    };
  }();

  var handleChangeSite = function handleChangeSite(name, value) {
    var nextSite = (0, _immer.default)(site, function (draft) {
      return (0, _lodash.set)(draft, "".concat(name), value);
    });
    dispatch({
      type: 'UPDATE_EDITOR_SITE',
      payload: nextSite
    });
  };

  var handleSelectImage = function handleSelectImage(name, image) {
    handleChangePost(name, image);
    dispatch({
      type: 'CLOSE_DIALOG'
    });
  };

  var handleChangeContent = function handleChangeContent(field) {
    if (field.global) {
      var nextSite = (0, _immer.default)(site, function (draft) {
        return (0, _lodash.set)(draft, "themeOptions.".concat(field.id), field);
      });
      dispatch({
        type: 'UPDATE_EDITOR_SITE',
        payload: nextSite
      });
    } else {
      var nextPost = (0, _immer.default)(post, function (draft) {
        return (0, _lodash.set)(draft, "content.".concat(field.id), field);
      });
      dispatch({
        type: 'UPDATE_EDITOR_POST',
        payload: nextPost
      });
    }
  };

  var handleSaveDraft = function handleSaveDraft() {
    handleSave('draft', 'draft');
  };

  var handlePublish = function handlePublish() {
    handleSave('publish', 'publish');
  };

  var handleUpdate = function handleUpdate(status) {
    handleSave('update', status);
  };

  var handleSave = /*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(action, status) {
      var _config$settings, id, themeOptions, frontPage, templateObject, postResult, siteResult, nextPostType, slug;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              id = site.id, themeOptions = site.themeOptions, frontPage = site.frontPage; // Trigger dummy message to give user feedback

              if (!(!siteHasChanged && !postHasChanged)) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return", _antd.message.success('Updated successfully'));

            case 3:
              templateObject = (0, _utils.getTemplateByPost)(post, fields); // Nullify template object if syncing is disabled or not in development mode

              if ((config === null || config === void 0 ? void 0 : (_config$settings = config.settings) === null || _config$settings === void 0 ? void 0 : _config$settings.sync) === false || process.env.NODE_ENV !== 'development') {
                templateObject = null;
              }

              setLoading(action); // Reset preview link so it can be regenerated.

              setPreviewLink(null);

              if (!siteHasChanged) {
                _context2.next = 11;
                break;
              }

              _context2.next = 10;
              return _actions.siteActions.updateSite({
                id: id,
                themeOptions: themeOptions,
                frontPage: frontPage
              }, dispatch, config);

            case 10:
              siteResult = _context2.sent;

            case 11:
              if (!(postHasChanged || action === 'publish')) {
                _context2.next = 16;
                break;
              }

              _context2.next = 14;
              return _actions.postActions.updatePost(_objectSpread(_objectSpread({
                siteID: id
              }, post), {}, {
                status: status,
                templateObject: templateObject
              }), dispatch, config);

            case 14:
              postResult = _context2.sent;

              // In case the user only updates the post, the new deployment status isn't available (only for site updates), so we need to manually update the site.
              if (!siteHasChanged) {
                dispatch({
                  type: 'ADD_SITE_SETTING',
                  payload: {
                    id: siteID,
                    key: 'deployment.undeployedChanges',
                    value: true
                  }
                });
              }

            case 16:
              setLoading('');

              if (postResult || siteResult) {
                _antd.message.success('Updated successfully'); // We need to generate the slug and navigate to it in case the user has changed the post name


                nextPostType = (0, _immer.default)(site.postTypes[post.postTypeID], function (draft) {
                  return (0, _lodash.set)(draft, "posts.".concat(post.id), post);
                });
                slug = (0, _utils.generateSlug)(nextPostType, post.id, site.frontPage, true);
                (0, _router.navigate)(slug);
              }

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSave(_x2, _x3) {
      return _ref15.apply(this, arguments);
    };
  }();

  var handleDiscard = function handleDiscard() {
    siteHasChanged && dispatch({
      type: 'ADD_EDITOR_SITE',
      payload: sites[siteID]
    });
    postHasChanged && onUndoChanges();
  };

  var handleDiscardRequest = function handleDiscardRequest() {
    dispatch({
      type: 'SET_DIALOG',
      payload: {
        open: true,
        title: 'Undo changes',
        component: /*#__PURE__*/_react.default.createElement(_antd.Space, {
          direction: "vertical",
          size: 20
        }, /*#__PURE__*/_react.default.createElement(_antd.Typography, {
          children: 'There are unsaved changes. Are you sure you want to discard them?'
        }), /*#__PURE__*/_react.default.createElement(_antd.Space, null, /*#__PURE__*/_react.default.createElement(_antd.Button, {
          children: "Undo changes",
          onClick: function onClick() {
            handleDiscard();
            dispatch({
              type: 'CLOSE_DIALOG'
            });
          }
        }), /*#__PURE__*/_react.default.createElement(_antd.Button, {
          children: "Back to Editor",
          type: "primary",
          onClick: function onClick() {
            return dispatch({
              type: 'CLOSE_DIALOG'
            });
          }
        }))),
        width: 320
      }
    });
  };

  var handleGeneratePreviewLink = /*#__PURE__*/function () {
    var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var result;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _actions.previewActions.generatePreviewLink({
                siteID: siteID,
                postID: post.id,
                expiryDate: expiryDate
              }, dispatch, config);

            case 2:
              result = _context3.sent;

              if (result) {
                setPreviewLink(result);
              }

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleGeneratePreviewLink() {
      return _ref16.apply(this, arguments);
    };
  }();

  var renderContent = function renderContent() {
    var template = (0, _utils.getTemplateByPost)(post, fields); // TODO: Very similar setup to utils function 'formatFieldsToProps'.
    // There might be a chance to unify the function.

    var formattedFields = template !== null && template !== void 0 && template.fields ? template.fields.map(function (o) {
      var field;

      if (o.global) {
        var _site$themeOptions, _site$themeOptions$o$; // Use field from themeOptions (single source of truth) and add value from site state


        field = _objectSpread(_objectSpread({}, fields === null || fields === void 0 ? void 0 : fields.themeOptions.find(function (p) {
          return p.id === o.id;
        })), {}, {
          value: site === null || site === void 0 ? void 0 : (_site$themeOptions = site.themeOptions) === null || _site$themeOptions === void 0 ? void 0 : (_site$themeOptions$o$ = _site$themeOptions[o.id]) === null || _site$themeOptions$o$ === void 0 ? void 0 : _site$themeOptions$o$.value
        });
      } else {
        var _post$content;

        field = (post === null || post === void 0 ? void 0 : (_post$content = post.content) === null || _post$content === void 0 ? void 0 : _post$content[o.id]) || o;
      }

      var formattedField = (0, _utils.formatFieldForEditor)({
        field: field,
        site: site
      });
      return _objectSpread(_objectSpread(_objectSpread({
        global: o.global
      }, field), o), {}, {
        value: formattedField === null || formattedField === void 0 ? void 0 : formattedField.value
      });
    }) : [];
    return /*#__PURE__*/_react.default.createElement(EditorFieldsContainer, null, /*#__PURE__*/_react.default.createElement(_EditorFields.default, {
      fields: formattedFields,
      onChangeElement: handleChangeContent
    }));
  };

  var renderThemeSettings = function renderThemeSettings() {
    // Loop over global options (only source of truth)
    var formattedFields = fields === null || fields === void 0 ? void 0 : fields.themeOptions.filter(function (o) {
      return !o.hide;
    }).map(function (o) {
      var _site$themeOptions2;

      var formattedField = (0, _utils.formatFieldForEditor)({
        // Pass in fields from editor site state or global option itself
        field: (site === null || site === void 0 ? void 0 : (_site$themeOptions2 = site.themeOptions) === null || _site$themeOptions2 === void 0 ? void 0 : _site$themeOptions2[o.id]) || o,
        site: site
      });
      return _objectSpread(_objectSpread({
        global: true
      }, o), {}, {
        value: formattedField === null || formattedField === void 0 ? void 0 : formattedField.value
      });
    });
    return /*#__PURE__*/_react.default.createElement(EditorFieldsContainer, null, /*#__PURE__*/_react.default.createElement(_EditorFields.default, {
      fields: formattedFields,
      onChangeElement: handleChangeContent
    }));
  };

  var renderSettings = function renderSettings() {
    var _sites$siteID, _sites$siteID$postTyp, _fields$postTypes, _fields$postTypes$pos;

    var postType = (_sites$siteID = sites[siteID]) === null || _sites$siteID === void 0 ? void 0 : (_sites$siteID$postTyp = _sites$siteID.postTypes) === null || _sites$siteID$postTyp === void 0 ? void 0 : _sites$siteID$postTyp[post === null || post === void 0 ? void 0 : post.postTypeID];
    var postTypeTemplates = fields === null || fields === void 0 ? void 0 : (_fields$postTypes = fields.postTypes) === null || _fields$postTypes === void 0 ? void 0 : (_fields$postTypes$pos = _fields$postTypes[post === null || post === void 0 ? void 0 : post.postTypeID]) === null || _fields$postTypes$pos === void 0 ? void 0 : _fields$postTypes$pos.templates;
    var postTypeTemplatesArray = postTypeTemplates ? Object.values(postTypeTemplates).filter(function (o) {
      return o.id !== 'archive';
    }) : []; // Get all templates with id 'archive'

    var archiveTemplatesArray = [];

    if ((post === null || post === void 0 ? void 0 : post.postTypeID) === 'page' && fields !== null && fields !== void 0 && fields.postTypes) {
      Object.values(fields === null || fields === void 0 ? void 0 : fields.postTypes).map(function (o) {
        return (o === null || o === void 0 ? void 0 : o.templates) && Object.values(o.templates).map(function (p) {
          return p.id === 'archive' && archiveTemplatesArray.push(p);
        });
      });
    }

    return /*#__PURE__*/_react.default.createElement(Content, null, /*#__PURE__*/_react.default.createElement(_antd.Space, {
      direction: "vertical",
      size: 20
    }, /*#__PURE__*/_react.default.createElement(_Input.default, {
      value: (post === null || post === void 0 ? void 0 : post.title) || '',
      onChange: function onChange(e) {
        return handleChangePost('title', e.target.value);
      },
      label: 'Title'
    }), /*#__PURE__*/_react.default.createElement(_Input.default, {
      value: (post === null || post === void 0 ? void 0 : post.id) === (site === null || site === void 0 ? void 0 : site.frontPage) ? '/' : (post === null || post === void 0 ? void 0 : post.slug) || '',
      onChange: function onChange(e) {
        return handleChangePost('slug', e.target.value);
      },
      label: 'Slug',
      disabled: (post === null || post === void 0 ? void 0 : post.id) === (site === null || site === void 0 ? void 0 : site.frontPage)
    }), (postTypeTemplatesArray.length > 1 || archiveTemplatesArray.length > 0) && /*#__PURE__*/_react.default.createElement(_Select.default, {
      value: post === null || post === void 0 ? void 0 : post.template,
      onChange: function onChange(value) {
        return handleChangePost('template', value);
      },
      label: 'Template'
    }, (postTypeTemplatesArray.length > 1 || archiveTemplatesArray.length > 0) && /*#__PURE__*/_react.default.createElement(_antd.Select.OptGroup, {
      label: 'Single'
    }, postTypeTemplatesArray.map(function (o) {
      return /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
        key: o.id,
        value: o.id,
        children: o.label || o.id
      });
    })), archiveTemplatesArray.length > 0 && /*#__PURE__*/_react.default.createElement(_antd.Select.OptGroup, {
      label: 'Archive'
    }, archiveTemplatesArray.map(function (o) {
      var id = "archive-".concat(o.postTypeID);
      return /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
        key: id,
        value: id,
        children: o.label
      });
    }))), /*#__PURE__*/_react.default.createElement(_Select.default, {
      value: (post === null || post === void 0 ? void 0 : post.status) || '',
      onChange: function onChange(value) {
        return handleChangePost('status', value);
      },
      label: 'Status'
    }, /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
      value: 'publish',
      children: 'Publish'
    }), /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
      value: 'draft',
      children: 'Draft'
    }), /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
      value: 'trash',
      children: 'Trash'
    })), (post === null || post === void 0 ? void 0 : post.postTypeID) === 'page' && /*#__PURE__*/_react.default.createElement(_PostTreeSelect.default, {
      label: "Parent",
      items: Object.values(postType.posts).filter(function (o) {
        return o.id !== post.id;
      }),
      value: post === null || post === void 0 ? void 0 : post.parentID,
      onChange: function onChange(value) {
        return handleChangePost('parentID', value);
      }
    }), (post === null || post === void 0 ? void 0 : post.taxonomies) && Object.keys(post.taxonomies).filter(function (k) {
      var _config$fields, _config$fields$taxono;

      return !!(config !== null && config !== void 0 && (_config$fields = config.fields) !== null && _config$fields !== void 0 && (_config$fields$taxono = _config$fields.taxonomies) !== null && _config$fields$taxono !== void 0 && _config$fields$taxono.find(function (o) {
        return o.id === k;
      }));
    }).map(function (k) {
      var o = sites[siteID].taxonomies[k];
      return o && /*#__PURE__*/_react.default.createElement(_Select.default, {
        key: k,
        onChange: function onChange(v) {
          return handleChangePost("taxonomies.".concat(k), v);
        },
        allowClear: true,
        placeholder: "Select category",
        mode: "multiple",
        label: o.title,
        defaultValue: post.taxonomies[k]
      }, o.terms && o.terms.map(function (p) {
        return /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
          key: p.id,
          value: p.id,
          children: p.title
        });
      }));
    }), (post === null || post === void 0 ? void 0 : post.postTypeID) !== 'page' && /*#__PURE__*/_react.default.createElement(_antd.Space, {
      direction: "vertical",
      size: 6
    }, /*#__PURE__*/_react.default.createElement(_Caption.default, {
      children: "Featured Image"
    }), /*#__PURE__*/_react.default.createElement(_FilePicker.default, {
      value: post === null || post === void 0 ? void 0 : post.featuredImage,
      onRemove: function onRemove() {
        return handleSelectImage('featuredImage', null);
      },
      onClick: function onClick() {
        return dispatch({
          type: "SET_DIALOG",
          payload: {
            open: true,
            component: /*#__PURE__*/_react.default.createElement(_MediaLibrary.default, {
              onSelect: function onSelect(v) {
                return handleSelectImage('featuredImage', v);
              },
              allow: ['image']
            }),
            width: 1024
          }
        });
      }
    })), (post === null || post === void 0 ? void 0 : post.postTypeID) === 'page' && /*#__PURE__*/_react.default.createElement(_antd.Checkbox, {
      value: post === null || post === void 0 ? void 0 : post.id,
      checked: (post === null || post === void 0 ? void 0 : post.id) === (site === null || site === void 0 ? void 0 : site.frontPage),
      onChange: function onChange(e) {
        return handleChangeSite('frontPage', e.target.checked ? e.target.value : '');
      },
      children: "Set as Homepage"
    })));
  };

  var renderSeo = function renderSeo() {
    var _post$seo, _post$seo2, _post$seo3;

    return /*#__PURE__*/_react.default.createElement(Content, null, /*#__PURE__*/_react.default.createElement(_antd.Space, {
      direction: "vertical",
      size: 25
    }, /*#__PURE__*/_react.default.createElement(_Input.default, {
      value: (post === null || post === void 0 ? void 0 : (_post$seo = post.seo) === null || _post$seo === void 0 ? void 0 : _post$seo.title) || '',
      onChange: function onChange(e) {
        return handleChangePost('seo.title', e.target.value);
      },
      label: 'SEO Title'
    }), /*#__PURE__*/_react.default.createElement(_Input.default, {
      value: (post === null || post === void 0 ? void 0 : (_post$seo2 = post.seo) === null || _post$seo2 === void 0 ? void 0 : _post$seo2.metaDesc) || '',
      onChange: function onChange(e) {
        return handleChangePost('seo.metaDesc', e.target.value);
      },
      label: 'SEO Description',
      rows: 4
    }), /*#__PURE__*/_react.default.createElement(_antd.Space, {
      direction: "vertical",
      size: 6
    }, /*#__PURE__*/_react.default.createElement(_Caption.default, {
      children: "Open Graph Image"
    }), /*#__PURE__*/_react.default.createElement(_FilePicker.default, {
      value: post === null || post === void 0 ? void 0 : (_post$seo3 = post.seo) === null || _post$seo3 === void 0 ? void 0 : _post$seo3.opengraphImage,
      onRemove: function onRemove() {
        return handleSelectImage('seo.opengraphImage', null);
      },
      onClick: function onClick() {
        return dispatch({
          type: "SET_DIALOG",
          payload: {
            open: true,
            component: /*#__PURE__*/_react.default.createElement(_MediaLibrary.default, {
              onSelect: function onSelect(v) {
                return handleSelectImage('seo.opengraphImage', v);
              },
              allow: ['image']
            }),
            width: 1024
          }
        });
      }
    }))));
  };

  var renderRevisions = function renderRevisions() {
    var _post$revisions;

    return /*#__PURE__*/_react.default.createElement(Content, null, /*#__PURE__*/_react.default.createElement(_antd.Space, {
      direction: "vertical"
    }, (post === null || post === void 0 ? void 0 : (_post$revisions = post.revisions) === null || _post$revisions === void 0 ? void 0 : _post$revisions.length) > 0 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Button, {
      type: !post.revisionID ? 'primary' : 'default',
      onClick: function onClick() {
        return !!post.revisionID && handleSelectRevision(post.id);
      },
      children: 'Current version',
      loading: loading === post.id,
      block: true
    }), post.revisions.map(function (o) {
      return /*#__PURE__*/_react.default.createElement(_antd.Button, {
        key: o.id,
        type: o.id === post.revisionID ? 'primary' : 'default',
        onClick: function onClick() {
          return o.id !== post.revisionID && handleSelectRevision(o.id);
        },
        children: o.title,
        loading: loading === o.id,
        block: true
      });
    })) : /*#__PURE__*/_react.default.createElement(_antd.Empty, {
      style: {
        padding: 20
      },
      imageStyle: {
        height: 120
      },
      description: 'No Revisions'
    })));
  };

  var renderPreview = function renderPreview() {
    return /*#__PURE__*/_react.default.createElement(Content, null, /*#__PURE__*/_react.default.createElement(_antd.Space, {
      direction: "vertical"
    }, (siteHasChanged || postHasChanged) && /*#__PURE__*/_react.default.createElement(_antd.Typography.Text, {
      type: "secondary"
    }, "Save the latest changes to include them in the preview."), /*#__PURE__*/_react.default.createElement(_Select.default, {
      value: expiryDate,
      onChange: function onChange(value) {
        return setExpiryDate(value);
      },
      label: 'Expiry date'
    }, /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
      value: 24,
      children: '1 Day'
    }), /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
      value: 48,
      children: '2 Days'
    }), /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
      value: 168,
      children: '1 Week'
    }), /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
      value: 720,
      children: '1 Month'
    })), previewLink ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Button, {
      children: "Copy to Clipboard",
      type: "primary",
      onClick: function onClick() {
        navigator.clipboard.writeText(previewLink);

        _antd.message.success('Copied to Clipboard');
      },
      block: true
    }), /*#__PURE__*/_react.default.createElement(_antd.Button, {
      children: "Open in new tab",
      onClick: function onClick() {
        return window.open(previewLink, '_blank');
      },
      type: "primary",
      block: true
    })) : /*#__PURE__*/_react.default.createElement(_antd.Button, {
      children: "Generate Link",
      onClick: handleGeneratePreviewLink,
      type: "primary",
      block: true
    })));
  };

  return /*#__PURE__*/_react.default.createElement(Container, (0, _extends2.default)({
    sidebar: sites === null || sites === void 0 ? void 0 : (_sites$siteID2 = sites[siteID]) === null || _sites$siteID2 === void 0 ? void 0 : (_sites$siteID2$editor = _sites$siteID2.editorOptions) === null || _sites$siteID2$editor === void 0 ? void 0 : _sites$siteID2$editor.sidebar
  }, rest), /*#__PURE__*/_react.default.createElement(Header, null, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    justify: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    size: 15
  }, postHasChanged || siteHasChanged ? /*#__PURE__*/_react.default.createElement(_antd.Button, {
    icon: /*#__PURE__*/_react.default.createElement(_icons.UndoOutlined, null),
    children: "Undo",
    onClick: handleDiscardRequest,
    size: "small",
    ghost: true
  }) : /*#__PURE__*/_react.default.createElement(_antd.Button, {
    icon: /*#__PURE__*/_react.default.createElement(_icons.HomeOutlined, null),
    type: "ghost",
    size: "small",
    ghost: true,
    onClick: function onClick() {
      if (postHasChanged || siteHasChanged) {
        handleDiscardRequest();
      } else {
        (0, _router.navigate)((0, _routes.default)("collection", {
          siteID: siteID,
          postTypeID: (post === null || post === void 0 ? void 0 : post.postTypeID) || 'page'
        }));
      }
    }
  })), /*#__PURE__*/_react.default.createElement(_antd.Space, {
    size: 15
  }, (post === null || post === void 0 ? void 0 : post.status) === 'draft' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    children: "Save Draft",
    onClick: handleSaveDraft,
    loading: loading === 'draft',
    size: "small",
    ghost: true
  }), /*#__PURE__*/_react.default.createElement(_antd.Button, {
    children: "Publish",
    onClick: handlePublish,
    loading: loading === 'publish',
    size: "small",
    ghost: true
  })), ((post === null || post === void 0 ? void 0 : post.status) === 'publish' || (post === null || post === void 0 ? void 0 : post.status) === 'trash') && /*#__PURE__*/_react.default.createElement(_antd.Button, {
    children: "Update",
    onClick: function onClick() {
      return handleUpdate(post.status);
    },
    loading: loading === 'update',
    size: "small",
    ghost: true
  })))), /*#__PURE__*/_react.default.createElement(TabsContainer, null, /*#__PURE__*/_react.default.createElement(_antd.Tabs, {
    activeKey: sidebar,
    tabBarGutter: 0,
    onChange: function onChange(value) {
      return setSidebar(value);
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Tabs.TabPane, {
    key: 'content',
    tab: 'Content',
    disabled: !editable
  }), /*#__PURE__*/_react.default.createElement(_antd.Tabs.TabPane, {
    key: 'settings',
    tab: 'Settings',
    disabled: !editable
  }), /*#__PURE__*/_react.default.createElement(_antd.Tabs.TabPane, {
    key: 'seo',
    tab: 'SEO',
    disabled: !editable
  })), /*#__PURE__*/_react.default.createElement(_antd.Dropdown.Button, {
    disabled: !editable,
    type: "text",
    overlay: /*#__PURE__*/_react.default.createElement(_antd.Menu, null, (post === null || post === void 0 ? void 0 : post.revisionsEnabled) && /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
      key: "preview",
      onClick: function onClick() {
        return setSidebar('preview');
      }
    }, "Share Preview"), (authUser === null || authUser === void 0 ? void 0 : (_authUser$capabilitie = authUser.capabilities) === null || _authUser$capabilitie === void 0 ? void 0 : _authUser$capabilitie.edit_theme_options) && (fields === null || fields === void 0 ? void 0 : (_fields$themeOptions = fields.themeOptions) === null || _fields$themeOptions === void 0 ? void 0 : (_fields$themeOptions$ = _fields$themeOptions.filter(function (o) {
      return !o.hide;
    })) === null || _fields$themeOptions$ === void 0 ? void 0 : _fields$themeOptions$.length) > 0 && /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
      key: 'theme',
      onClick: function onClick() {
        return setSidebar('theme');
      }
    }, "Theme"), (post === null || post === void 0 ? void 0 : post.revisionsEnabled) && /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
      key: "revisions",
      onClick: function onClick() {
        return setSidebar('revisions');
      }
    }, "Revisions"), /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
      key: "sidebar",
      onClick: onToggleSidebar
    }, "Toggle Sidebar ", /*#__PURE__*/_react.default.createElement(_antd.Typography.Text, {
      keyboard: true
    }, "ESC")))
  })), /*#__PURE__*/_react.default.createElement(TabContainer, null, sidebar === 'content' && renderContent(), sidebar === 'settings' && renderSettings(), sidebar === 'seo' && renderSeo(), sidebar === 'revisions' && (post === null || post === void 0 ? void 0 : post.revisionsEnabled) && renderRevisions(), sidebar === 'theme' && renderThemeSettings(), sidebar === 'preview' && renderPreview(), (postHasChanged || siteHasChanged) && /*#__PURE__*/_react.default.createElement(AlertContainer, null, /*#__PURE__*/_react.default.createElement(_antd.Alert, {
    message: "Links have been disabled",
    showIcon: false,
    banner: true,
    style: {
      background: 'transparent'
    },
    action: /*#__PURE__*/_react.default.createElement(_antd.Button, {
      icon: /*#__PURE__*/_react.default.createElement(_icons.QuestionCircleOutlined, null),
      type: "link",
      size: "small",
      onClick: function onClick() {
        return dispatch({
          type: 'SET_DIALOG',
          payload: {
            open: true,
            title: 'Information',
            component: /*#__PURE__*/_react.default.createElement(_antd.Space, {
              direction: "vertical",
              size: 20
            }, /*#__PURE__*/_react.default.createElement(_antd.Typography, null, "All links on the website have been temporarily disabled to avoid content loss."), /*#__PURE__*/_react.default.createElement(_antd.Typography, null, "Update the post or undo your changes by clicking on the circle arrow icon in the top left corner."), /*#__PURE__*/_react.default.createElement(_antd.Button, {
              onClick: function onClick() {
                return dispatch({
                  type: 'CLOSE_DIALOG'
                });
              }
            }, "Got it")),
            width: 500
          }
        });
      }
    })
  }))));
};

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  position: fixed;\n  z-index: 1000;\n  left: ", ";\n  right: ", ";\n  top: 0;\n  width: ", ";\n  height: 100vh;\n  background: ", ";\n  border-right: 1px solid ", ";\n  box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.034), 0 6.7px 5.3px rgba(0, 0, 0, 0.048),\n    0 12.5px 10px rgba(0, 0, 0, 0.06), 0 22.3px 17.9px rgba(0, 0, 0, 0.072),\n    0 41.8px 33.4px rgba(0, 0, 0, 0.086), 0 100px 80px rgba(0, 0, 0, 0.12);\n\n  .ant-tabs > .ant-tabs-nav {\n    margin-bottom: 0;\n  }\n"])), function (_ref) {
  var position = _ref.sidebar.position;
  return position === 'left' ? 0 : 'unset';
}, function (_ref2) {
  var position = _ref2.sidebar.position;
  return position === 'left' ? 'unset' : 0;
}, function (_ref3) {
  var width = _ref3.sidebar.width;
  return "".concat(width, "px");
}, _theme.colors.secondaryContrast, _theme.colors.tertiary);

var Header = _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  padding: 15px;\n  background: ", ";\n\n  button {\n    &:hover {\n      border-color: #fff;\n      background-color: #fff !important;\n    }\n  }\n"])), _theme.colors.primary);

var TabsContainer = _styledComponents.default.div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-right: 10px;\n  background: #fff;\n\n  .ant-tabs-nav-wrap {\n    padding: 0 15px;\n  }\n"])));

var TabContainer = _styledComponents.default.div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  overflow: auto;\n  white-space: pre-wrap;\n  height: calc(100vh - 95px);\n  scrollbar-width: thin;\n\n  &&::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  &&::-webkit-scrollbar-track {\n    border-radius: 4px;\n  }\n\n  &&::-webkit-scrollbar-thumb {\n    border-radius: 4px;\n    background: ", ";\n  }\n"])), _theme.colors.tertiary);

var Content = _styledComponents.default.div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n  padding: 15px;\n  min-height: calc(100% - 46px);\n"])));

var EditorFieldsContainer = _styledComponents.default.div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n  min-height: calc(100% - 46px);\n"])));

var AlertContainer = _styledComponents.default.div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n  height: 45px;\n  border-top: 1px solid #d9d9d9;\n"])));

var _default = EditorSidebar;
exports.default = _default;